import './home.scss';

import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { useAppSelector } from 'app/config/store';
import { ToastContext } from 'app/context/ToastContext';
import { SortOrder } from 'primereact/api';
import { getEntities } from 'app/api/generalApi';
import { classNames } from 'primereact/utils';
import { DataView } from 'primereact/dataview';
import { useNavigate } from 'react-router-dom';

export const EmailMessageComponent = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const navigate = useNavigate();

  const account = useAppSelector(state => state.authentication.account);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 3,
    page: 0,
    sortField: 'id',
    sortOrder: SortOrder.DESC,
    filter: '',
  });

  useEffect(() => {
    loadData();
  }, [lazyParams]);

  const loadData = () => {
    setLoading(true);

    const sort = lazyParams.sortField
      ? lazyParams.sortField + (lazyParams.sortOrder ? ',' + (lazyParams.sortOrder === SortOrder.DESC ? 'desc' : 'asc') : '')
      : null;

    const requestData = {
      page: lazyParams.page,
      size: lazyParams.rows,
      sort,
      ...(lazyParams.filter ? { query: lazyParams.filter } : {}),
    };

    getEntities('/api/email-messages', requestData)
      .then(response => {
        setData(response.data.content);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const onDetail = emailMessage => {
    navigate(`/mail/inbox/${emailMessage.id}`);
  };

  const itemTemplate = (emailMessage, index) => {
    return (
      <div className="col-12" key={emailMessage.id}>
        <div
          className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', {
            'border-top-1 surface-border': index !== 0,
          })}
        >
          {emailMessage?.insuranceCompany?.logo && (
            <img
              className="w-4 sm:w-5rem xl:w-5rem shadow-2 block xl:block mx-auto border-round"
              src={`https://system.nfagroup.eu/api/insurance-companies/logo/${emailMessage.insuranceCompany.id}`}
              alt={emailMessage.subject}
            />
          )}
          {!emailMessage?.insuranceCompany?.logo && (
            <div className="w-4 sm:w-5rem xl:w-5rem shadow-2 block xl:block mx-auto border-round" />
          )}
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <div className="one-line-clamp font-bold text-900">{emailMessage.subject}</div>
              {/*<Rating value={product.rating} readOnly cancel={false}></Rating>*/}
              <div className="flex align-items-center gap-3">
                <span className="flex align-items-center gap-2">
                  <span className="three-line-clamp" dangerouslySetInnerHTML={{ __html: emailMessage.message }}></span>
                </span>
                {/*<Tag value={product.inventoryStatus} severity={getSeverity(product)}></Tag>*/}
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              <Button icon="pi pi-arrow-right" className="p-button-rounded" type="button" onClick={() => onDetail(emailMessage)}></Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const listTemplate = items => {
    if (!items || items.length === 0) return null;

    const list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <div>
      <h5>Zoznam noviniek</h5>
      <DataView value={data} itemTemplate={itemTemplate} emptyMessage="Žiadne novinky" />
      <div className="outlined mt-2" style={{ justifySelf: 'center' }}>
        {data?.length > 0 && (
          <Button type="button" onClick={() => navigate('/mail/inbox')}>
            <b>Načítať ďalšie novinky...</b>
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmailMessageComponent;
